import { render, staticRenderFns } from "./SickDaysView.vue?vue&type=template&id=2f6e339d&scoped=true"
import script from "./SickDaysView.vue?vue&type=script&lang=js"
export * from "./SickDaysView.vue?vue&type=script&lang=js"
import style0 from "./SickDaysView.vue?vue&type=style&index=0&id=2f6e339d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e339d",
  null
  
)

export default component.exports